module.exports = __webpack_public_path__ + "img/picture1.32595fb1.jpg";